/* ms-wishlist.js · v1 · 2026-10-09 · modernsleeping.de
   Merkliste ohne App. Gespeichert nur im Browser (localStorage, kein Cookie).
   - Herz neben jeder Produktkarte (a.ms-cr-card) – als eigenes Element NEBEN dem Link,
     nicht darin (gültiges HTML, Screenreader-freundlich)
   - bindet den vorhandenen Button .ms-cr-card__wish (ms-collection-redesign) an
   - Herz neben dem Produkttitel (.product-meta__title)
   - Herz mit Zähler im Header (vor dem Konto-Symbol)
   - <ms-wishlist-grid> auf der Merkliste-Seite lädt Karten über die Section Rendering API */

(() => {
  if (window.__msWishlist) return;
  window.__msWishlist = true;

  const cfg = window.msExt || {};
  const KEY = 'ms:wishlist';
  const root = (cfg.root || '/').replace(/\/$/, '');

  const HEART = '<svg width="18" height="17" viewBox="0 0 15 14" fill="none" aria-hidden="true" focusable="false"><path d="M7.5 13S1 9 1 5a3.9 3.9 0 017.5-1.5A3.9 3.9 0 0115 5c0 4-6.5 8-7.5 8z" stroke="currentColor" stroke-width="1.2"/></svg>';

  const store = {
    get() {
      try {
        return JSON.parse(window.localStorage.getItem(KEY)) || [];
      } catch (e) {
        return [];
      }
    },
    set(list) {
      try {
        window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, 60)));
      } catch (e) {
        /* Speicher nicht verfügbar */
      }
    }
  };

  const handleFromHref = (href) => {
    const m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  };

  /* Statusmeldung für Screenreader und sichtbar */
  let toastEl;
  const toast = (msg) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'ms-wl-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-visible'), 2600);
  };

  const sync = () => {
    const list = store.get();
    document.querySelectorAll('[data-ms-wishlist]').forEach((btn) => {
      const active = list.includes(btn.dataset.msWishlist);
      btn.setAttribute('aria-pressed', String(active));
      btn.classList.toggle('is-active', active);
    });
    document.querySelectorAll('[data-ms-wishlist-count]').forEach((el) => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  };

  const toggle = (handle) => {
    const list = store.get();
    const add = !list.includes(handle);
    store.set(add ? [handle, ...list] : list.filter((h) => h !== handle));
    sync();
    toast(add ? 'Auf der Merkliste gespeichert' : 'Von der Merkliste entfernt');
    document.dispatchEvent(new CustomEvent('ms:wishlist-change'));
  };

  const makeButton = (handle, title, extraClass) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = `ms-wl-btn ${extraClass || ''}`.trim();
    btn.dataset.msWishlist = handle;
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', `${title || 'Produkt'} auf die Merkliste`);
    btn.innerHTML = HEART;
    return btn;
  };

  /* Karten, Produktseite, Header ergänzen */
  const enhance = () => {
    // Produktkarten aus snippets/product-item.liquid (<a class="ms-cr-card">)
    document.querySelectorAll('a.ms-cr-card:not([data-ms-wl])').forEach((card) => {
      card.setAttribute('data-ms-wl', '');
      const handle = handleFromHref(card.getAttribute('href'));
      if (!handle) return;
      const wrap = document.createElement('div');
      wrap.className = 'ms-wl-wrap';
      card.parentNode.insertBefore(wrap, card);
      wrap.appendChild(card);
      const name = card.querySelector('.ms-cr-card__name');
      wrap.appendChild(makeButton(handle, name ? name.textContent.trim() : '', 'ms-wl-btn--card'));
    });

    // Vorhandener Button in ms-collection-redesign
    document.querySelectorAll('.ms-cr-card__wish:not([data-ms-wishlist])').forEach((btn) => {
      const card = btn.closest('.ms-cr-card');
      const link = card && card.querySelector('a[href*="/products/"]');
      const handle = link && handleFromHref(link.getAttribute('href'));
      if (!handle) return;
      btn.dataset.msWishlist = handle;
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('aria-label', 'Auf die Merkliste');
    });

    // Produktseite
    if (cfg.product) {
      const title = document.querySelector('h1.product-meta__title');
      if (title && !title.parentNode.querySelector('.ms-wl-btn--product')) {
        title.insertAdjacentElement('afterend', makeButton(cfg.product, title.textContent.trim(), 'ms-wl-btn--product'));
      }
    }

    // Header
    if (cfg.headerIcon && cfg.wishlistUrl && !document.querySelector('.ms-wl-header')) {
      const account = [...document.querySelectorAll('.header__icon-list a.header__icon-wrapper')].find((a) => /\/account/.test(a.getAttribute('href') || ''));
      if (account) {
        const link = document.createElement('a');
        link.href = cfg.wishlistUrl;
        link.className = `${account.className} ms-wl-header`;
        link.setAttribute('aria-label', 'Merkliste');
        link.innerHTML = `${HEART}<span class="ms-wl-count" data-ms-wishlist-count hidden></span>`;
        account.parentNode.insertBefore(link, account);
      }
    }
    sync();
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-ms-wishlist]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.dataset.msWishlist);
  });

  /* Merkliste-Seite */
  class MsWishlistGrid extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-list]');
      this.empty = this.querySelector('[data-empty]');
      this.render();
      document.addEventListener('ms:wishlist-change', () => this.render());
    }
    async render() {
      const handles = store.get();
      const cards = await Promise.all(
        handles.map(async (h) => {
          try {
            const res = await fetch(`${root}/products/${encodeURIComponent(h)}?section_id=ms-product-card`);
            if (!res.ok) return null;
            const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
            const el = doc.querySelector('[data-card-root]');
            return el && el.innerHTML.trim() ? el.innerHTML : null;
          } catch (e) {
            return null;
          }
        })
      );
      this.list.innerHTML = cards.filter(Boolean).join('');
      if (this.empty) this.empty.hidden = this.list.children.length > 0;
      enhance();
    }
  }
  if (!customElements.get('ms-wishlist-grid')) customElements.define('ms-wishlist-grid', MsWishlistGrid);

  const start = () => {
    enhance();
    new MutationObserver(() => {
      clearTimeout(start._t);
      start._t = setTimeout(enhance, 120);
    }).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
